document.addEventListener("DOMContentLoaded", function () {
  // Check password cache immediately on page load
  const CACHE_KEY = "collection_vault_unlocked";
  const CACHE_EXPIRY_KEY = "collection_vault_unlocked_expiry";
  
  function checkPasswordCache() {
    const cached = localStorage.getItem(CACHE_KEY);
    const expiry = localStorage.getItem(CACHE_EXPIRY_KEY);
    
    if (cached && expiry) {
      const now = new Date().getTime();
      const expiryTime = parseInt(expiry);
      
      if (now < expiryTime) {
        // Cache is still valid, auto-unlock immediately
        console.log("Password cache valid, auto-unlocking collection");
        unlockBodyScroll();
        const vault = document.querySelector(".collection-vault");
        if (vault) {
          vault.style.display = "none";
        }
        return true;
      } else {
        // Cache expired, clear it
        localStorage.removeItem(CACHE_KEY);
        localStorage.removeItem(CACHE_EXPIRY_KEY);
      }
    }
    return false;
  }

  // Check for password change - if password changed, clear cache and lock page
  function checkPasswordChange() {
    const config = window.collectionVaultConfig;
    const storedPassword = localStorage.getItem("collection_vault_password");
    
    if (storedPassword && storedPassword.toLowerCase() !== config.unlockPassword.toLowerCase()) {
      // Password has changed, clear all cache
      localStorage.removeItem(CACHE_KEY);
      localStorage.removeItem(CACHE_EXPIRY_KEY);
      localStorage.removeItem("collection_vault_password");
      console.log("Password changed, cache cleared - page locked");
      return true; // Password changed, page should be locked
    }
    
    // Store current password for future comparison
    if (config.unlockPassword) {
      localStorage.setItem("collection_vault_password", config.unlockPassword);
    }
    
    return false; // Password unchanged
  }

  // Check for password change first
  if (checkPasswordChange()) {
    // Password changed, don't auto-unlock
  } else if (checkPasswordCache()) {
    // Password unchanged and cache valid, unlock and exit
    return; // Exit early, no need to process anything else
  }

  const form = document.getElementById("collection-vault-form");
  const emailWrapper = document.querySelector(
    ".collection-vault__input-wrapper:not(.collection-vault__input-wrapper--hidden)"
  );
  const phoneWrapper = document.getElementById("phone-wrapper");
  const emailInput = document.getElementById("email-input");
  const phoneInput = document.getElementById("phone-input");
  const nextBtn = document.getElementById("next-btn");
  const step1Text = document.getElementById("step1-text");
  const step2Text = document.getElementById("step2-text");
  const inputGroupEl = document.querySelector(".collection-vault__input-group");
  // progress UI removed per request

  let currentStep = 1;
  let iti = null; // International phone input instance

  // Phone is a second-step field; keep it inactive on initial load.
  if (phoneInput) {
    phoneInput.disabled = true;
    phoneInput.required = false;
  }

  // Body scroll lock functionality
  function lockBodyScroll() {
    const body = document.body;
    const scrollY = window.scrollY;

    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.width = "100%";
    body.style.overflow = "hidden";
  }

  function unlockBodyScroll() {
    const body = document.body;
    const scrollY = body.style.top;

    body.style.position = "";
    body.style.top = "";
    body.style.width = "";
    body.style.overflow = "";

    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  }

  // Lock body scroll when vault loads
  lockBodyScroll();

  // Countdown timer functionality using Day.js for reliable timezone handling
  function initializeCountdown() {
    const config = window.collectionVaultConfig;

    if (!config.countdownEnabled) {
      return;
    }

    const countdownEl = document.getElementById("countdown-timer");
    const countdownTextEl = document.getElementById("countdown-text");

    if (!countdownEl || !countdownTextEl) {
      return;
    }

    // Check if Day.js is available
    if (typeof window.dayjs === 'undefined') {
      console.error("Day.js library not loaded");
      countdownTextEl.textContent = "Countdown unavailable";
      return;
    }

    // Initialize Day.js with plugins
    const dayjs = window.dayjs;
    dayjs.extend(window.dayjs_plugin_utc);
    dayjs.extend(window.dayjs_plugin_timezone);

    const countdownText = config.countdownText || "Collection unlocks in:";
    const targetDateString = config.countdownDate;

    function updateCountdown() {
      try {
        // Parse target date using Day.js (consistent across all devices)
        const targetDate = dayjs.tz(targetDateString, 'America/New_York');
        
        if (!targetDate.isValid()) {
          throw new Error("Invalid target date format");
        }

        // Get current time in EDT using Day.js
        const nowEDT = dayjs.tz(dayjs(), 'America/New_York');
        
        // Calculate difference in milliseconds
        const distance = targetDate.valueOf() - nowEDT.valueOf();

        // Debug logging
        console.log("Countdown Debug:", {
          targetDateString: targetDateString,
          targetDate: targetDate.format(),
          nowEDT: nowEDT.format(),
          distance: distance,
          isValidTarget: targetDate.isValid(),
          isValidNow: nowEDT.isValid()
        });

        if (distance < 0) {
          // Countdown finished - unlock the collection
          countdownTextEl.textContent = "Collection is now unlocked!";
          countdownEl.style.color = "#22c55e";

          // Hide the vault and unlock scroll after a short delay
          setTimeout(() => {
            unlockBodyScroll();
            // Hide the vault section
            const vault = document.querySelector(".collection-vault");
            if (vault) {
              vault.style.display = "none";
            }
          }, 2000);

          return;
        }

        // Calculate time components using Day.js
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Format countdown display
        let timeString = "";
        
        // Check if we have valid numbers
        if (isNaN(days) || isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
          countdownTextEl.textContent = "Loading countdown...";
          return;
        }
        
        if (days > 0) {
          timeString = `${days}d ${hours}h ${minutes}m ${seconds}s`;
        } else if (hours > 0) {
          timeString = `${hours}h ${minutes}m ${seconds}s`;
        } else if (minutes > 0) {
          timeString = `${minutes}m ${seconds}s`;
        } else {
          timeString = `${seconds}s`;
        }

        countdownTextEl.textContent = `${countdownText} ${timeString}`;

      } catch (error) {
        console.error("Countdown error:", error);
        countdownTextEl.textContent = "Countdown unavailable";
      }
    }

    // Update countdown immediately and then every second
    updateCountdown();
    const countdownInterval = setInterval(updateCountdown, 1000);

    // Clean up interval when page unloads
    window.addEventListener("beforeunload", () => {
      clearInterval(countdownInterval);
    });
  }

  // Initialize countdown
  initializeCountdown();

  // GeoIP lookup function for auto-detecting country
  async function geoIpLookup(callback) {
    try {
      const providers = [
        "https://geolocation-db.com/json/",
      ];
  
      for (const url of providers) {
        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 1200);
          const response = await fetch(url, {
            signal: controller.signal,
            cache: "no-store",
          });
          clearTimeout(timeoutId);
  
          if (!response.ok) {
            continue;
          }
  
          const data = await response.json();
          const rawCountryCode =
            data.country_code || data.countryCode || data.country_code_iso3166;
  
          if (typeof rawCountryCode === "string" && rawCountryCode.length >= 2) {
            const countryCode = rawCountryCode.slice(0, 2).toLowerCase();
            callback(countryCode);
          }
        } catch (error) {
          console.warn("Country lookup provider failed:", url, error);
        }
      }
    } catch (error) {
      console.error("GeoIP lookup failed:", error);
      // Fallback to default country on error
      callback("us");
    }
  }

  // Load utils once with CDN fallback; reuse same promise.
  let intlTelUtilsPromise = null;
  function loadIntlTelUtils() {
    if (intlTelUtilsPromise) return intlTelUtilsPromise;

    const utilsUrls = [
      "https://cdn.jsdelivr.net/npm/intl-tel-input@25.10.10/build/js/utils.js",
      "https://unpkg.com/intl-tel-input@25.10.10/build/js/utils.js",
    ];

    const importWithFallback = (index) => {
      if (index >= utilsUrls.length) {
        return Promise.reject(new Error("Unable to load intl-tel-input utils"));
      }

      return import(utilsUrls[index]).catch((error) => {
        console.warn("Failed to load intl-tel-input utils from", utilsUrls[index], error);
        return importWithFallback(index + 1);
      });
    };

    intlTelUtilsPromise = importWithFallback(0);
    return intlTelUtilsPromise;
  }

  // Start fetching utils as early as possible (non-blocking).
  loadIntlTelUtils().catch((error) => {
    console.warn("intl-tel-input utils preload failed:", error);
  });

  // Initialize international phone input if not already done
  if (
    !iti &&
    window.intlTelInput &&
    window.collectionVaultConfig.emailFormEnabled === true
  ) {
    try {
      iti = window.intlTelInput(phoneInput, {
        initialCountry: "auto",
        useFullscreenPopup: false,
        geoIpLookup: geoIpLookup,
        loadUtils: loadIntlTelUtils,
      });
      console.log("International phone input initialized:", iti);
    } catch (error) {
      console.error("Failed to initialize international phone input:", error);
    }
  }

  // Validation functions
  function showValidationError(input, message) {
    clearValidationError(input);
    const errorDiv = document.createElement("div");
    errorDiv.className = "collection-vault__validation-error";
    errorDiv.textContent = message;
    inputGroupEl.appendChild(errorDiv);
  }

  function clearValidationError(input) {
    const existingError = inputGroupEl.querySelector(
      ".collection-vault__validation-error"
    );
    if (existingError) {
      existingError.remove();
    }
  }

  // Next button functionality
  if (window.collectionVaultConfig.emailFormEnabled === true) {
    nextBtn.addEventListener("click", function () {
      const emailValue = emailInput.value.trim();

      if (!emailValue) {
        showValidationError(emailInput, "Please enter your email address");
        emailInput.focus();
        return;
      }

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        showValidationError(emailInput, "Please enter a valid email address");
        emailInput.focus();
        return;
      }

      // Clear any existing validation errors
      clearValidationError(emailInput);

      // Show loading state for next button
      const nextBtnText = nextBtn.querySelector(".collection-vault__next-text");
      const originalNextText = nextBtnText.textContent;
      nextBtnText.textContent = "Joining...";
      nextBtn.disabled = true;

      // Submit email to Klaviyo immediately
      submitEmailToKlaviyo(emailValue)
        .then(() => {
          fbq('track', 'CompleteRegistration')

          // Move to phone step
          currentStep = 2;
          emailWrapper.classList.add("collection-vault__input-wrapper--hidden");
          phoneWrapper.classList.remove("collection-vault__input-wrapper--hidden");
          phoneInput.disabled = false;
          phoneInput.required = true;
          if (iti && typeof iti.setDisabled === "function") {
            iti.setDisabled(false);
          }

          phoneInput.focus();
          // Toggle step texts
          if (step1Text && step2Text) {
            step1Text.classList.add("collection-vault__input-wrapper--hidden");
            step2Text.classList.remove("collection-vault__input-wrapper--hidden");
          }
        })
        .catch((error) => {
          console.error("Klaviyo email submission error:", error);
          showValidationError(emailInput, "Sorry, there was an error. Please try again.");
        })
        .finally(() => {
          // Reset button state
          nextBtnText.textContent = originalNextText;
          nextBtn.disabled = false;
        });
    });

    // Handle form submission
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const emailValue = emailInput.value.trim();
      const phoneValue = phoneInput.value.trim();

      // Enter on step 1 should behave exactly like clicking JOIN.
      if (currentStep === 1) {
        nextBtn.click();
        return;
      }

      // Validate both fields
      if (!emailValue) {
        showValidationError(emailInput, "Please enter your email address");
        emailInput.focus();
        return;
      }

      if (!phoneValue) {
        showValidationError(phoneInput, "Please enter your phone number");
        phoneInput.focus();
        return;
      }

      // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailValue)) {
        showValidationError(emailInput, "Please enter a valid email address");
        emailInput.focus();
        return;
      }

      // Validate phone number using intl-tel-input
      if (iti) {
        // `isValidNumber` is strict and depends on utils.js; if utils is still loading,
        // don't block submission on a false negative.
        const utilsReady =
          !!window.intlTelInputUtils ||
          !!(window.intlTelInputGlobals && window.intlTelInputGlobals.utils);

        console.log(
          "Phone validation - iti exists, checking number:",
          phoneValue
        );
        const validationResult = utilsReady ? iti.isValidNumber() : true;
        console.log(
          "Phone validation - isValidNumber result:",
          validationResult
        );
        console.log("Phone validation - getNumber result:", iti.getNumber());

        if (!validationResult) {
          showValidationError(
            phoneInput,
            "Please enter a valid phone number for the selected country"
          );
          phoneInput.focus();
          return;
        }
      }

      // Clear any existing validation errors
      clearValidationError(emailInput);
      clearValidationError(phoneInput);

      // Show loading state
      const submitBtn = document.querySelector(".collection-vault__submit-btn");
      const originalText = submitBtn.querySelector(
        ".collection-vault__submit-text"
      ).textContent;
      submitBtn.querySelector(".collection-vault__submit-text").textContent =
        "Joining...";
      submitBtn.disabled = true;

      // Get the full international phone number
      let fullPhoneNumber = phoneValue;
      if (iti) {
        const itiNumber = iti.getNumber();
        console.log("iti.getNumber() returned:", itiNumber);

        if (itiNumber) {
          fullPhoneNumber = itiNumber;
        } else {
          // If getNumber() returns empty, construct it manually
          const selectedCountryData = iti.getSelectedCountryData();
          console.log("Selected country data:", selectedCountryData);

          if (selectedCountryData && selectedCountryData.dialCode) {
            // Get the raw phone number without formatting
            const cleanNumber = phoneValue.replace(/[\s\-\(\)]/g, "");
            // Check if it already has the country code
            if (cleanNumber.startsWith("+")) {
              fullPhoneNumber = cleanNumber;
            } else if (cleanNumber.startsWith(selectedCountryData.dialCode)) {
              fullPhoneNumber = "+" + cleanNumber;
            } else {
              fullPhoneNumber =
                "+" + selectedCountryData.dialCode + cleanNumber;
            }
          }
        }
      }
      console.log("Full phone number to submit:", fullPhoneNumber);

      // Submit phone to Klaviyo
      submitPhoneToKlaviyo(fullPhoneNumber)
        .then(() => {
          // Show success message
          showSuccessMessage();
          // Reset form
          emailInput.value = "";
          phoneInput.value = "";
          // Clear validation errors
          clearValidationError(emailInput);
          clearValidationError(phoneInput);
          // Reset international phone input
          if (iti) {
            iti.setNumber("");
          }
          // Reset to first step
          currentStep = 1;
          emailWrapper.classList.remove(
            "collection-vault__input-wrapper--hidden"
          );
          phoneWrapper.classList.add("collection-vault__input-wrapper--hidden");
          phoneInput.disabled = true;
          phoneInput.required = false;
          if (iti && typeof iti.setDisabled === "function") {
            iti.setDisabled(true);
          }
          if (step1Text && step2Text) {
            step2Text.classList.add("collection-vault__input-wrapper--hidden");
            step1Text.classList.remove(
              "collection-vault__input-wrapper--hidden"
            );
          }
          // Unlock body scroll after successful submission
          setTimeout(() => {
            unlockBodyScroll();
          }, 3000); // Wait for success message to show
          // progress UI removed
        })
        .catch((error) => {
          console.error("Klaviyo submission error:", error);
          alert("Sorry, there was an error. Please try again.");
        })
        .finally(() => {
          // Reset button state
          submitBtn.querySelector(
            ".collection-vault__submit-text"
          ).textContent = originalText;
          submitBtn.disabled = false;
        });
    });
  }

  // Submit email to Klaviyo
  async function submitEmailToKlaviyo(email) {
    const config = window.collectionVaultConfig;

    if (!config.klaviyoPublicKey || !config.emailListId) {
      throw new Error(
        "Klaviyo configuration is missing. Please check your section settings."
      );
    }

    const PUBLIC_API_KEY = config.klaviyoPublicKey;
    const EMAIL_LIST_ID = config.emailListId;

    // Submit to email list
    const emailPayload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: email },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: EMAIL_LIST_ID,
            },
          },
        },
      },
    };

    try {
      const emailResponse = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`,
        {
          method: "POST",
          headers: {
            "content-type": "application/vnd.api+json",
            accept: "application/vnd.api+json",
            revision: "2025-07-15",
          },
          body: JSON.stringify(emailPayload),
        }
      );

      if (!emailResponse.ok) {
        throw new Error(`Email subscription failed: ${emailResponse.status}`);
      }

      return { success: true };
    } catch (error) {
      console.error("Klaviyo email submission error:", error);
      throw error;
    }
  }

  // Submit phone to Klaviyo
  async function submitPhoneToKlaviyo(phone) {
    const config = window.collectionVaultConfig;

    if (!config.klaviyoPublicKey || !config.smsListId) {
      throw new Error(
        "Klaviyo configuration is missing. Please check your section settings."
      );
    }

    const PUBLIC_API_KEY = config.klaviyoPublicKey;
    const SMS_LIST_ID = config.smsListId;

    // Submit to SMS list
    const smsPayload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { phone_number: phone },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: SMS_LIST_ID,
            },
          },
        },
      },
    };

    try {
      const smsResponse = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`,
        {
          method: "POST",
          headers: {
            "content-type": "application/vnd.api+json",
            accept: "application/vnd.api+json",
            revision: "2025-07-15",
          },
          body: JSON.stringify(smsPayload),
        }
      );

      if (!smsResponse.ok) {
        throw new Error(`SMS subscription failed: ${smsResponse.status}`);
      }

      return { success: true };
    } catch (error) {
      console.error("Klaviyo phone submission error:", error);
      throw error;
    }
  }

  // Show success message
  function showSuccessMessage(customMessage) {
    const message =
      customMessage || "Thank you! You've been added to our list.";

    // Create success notification
    const notification = document.createElement("div");
    notification.className = "collection-vault__success-notification";
    notification.innerHTML = `
      <div class="collection-vault__success-content">
        <span class="collection-vault__success-icon">✓</span>
        <span class="collection-vault__success-text">${message}</span>
      </div>
    `;

    document
      .querySelector(".collection-vault__form-container")
      .appendChild(notification);

    // Remove notification after 3 seconds
    setTimeout(() => {
      notification.remove();
    }, 3000);
  }

  if (window.collectionVaultConfig.emailFormEnabled === true) {
    // Handle Enter key in inputs
    [emailInput, phoneInput].forEach((input) => {
      input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          if (input === emailInput && currentStep === 1) {
            nextBtn.click();
            return;
          }
          form.dispatchEvent(new Event("submit"));
        }
      });
    });
  }

  // Password form functionality
  const passwordForm = document.getElementById("password-form");
  const passwordInput = document.getElementById("password-input");

  if (passwordForm && passwordInput) {
    const config = window.collectionVaultConfig;
    const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    // Cache the password
    function cachePassword() {
      const expiryTime = new Date().getTime() + CACHE_DURATION;
      localStorage.setItem(CACHE_KEY, "true");
      localStorage.setItem(CACHE_EXPIRY_KEY, expiryTime.toString());
      console.log("Password cached until:", new Date(expiryTime));
    }

    passwordForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const enteredPassword = passwordInput.value.trim();

      if (!enteredPassword) {
        showValidationError(passwordInput, "Please enter the password");
        passwordInput.focus();
        return;
      }

      if (enteredPassword.toLowerCase() === config.unlockPassword.toLowerCase()) {
        // Correct password - cache it and unlock the collection
        cachePassword();
        showSuccessMessage("Collection unlocked! Redirecting...");

        // Hide vault and unlock scroll after delay for first-time users
        setTimeout(() => {
          unlockBodyScroll();
          const vault = document.querySelector(".collection-vault");
          if (vault) {
            vault.style.display = "none";
          }
        }, 2000);
        fbq('track', 'CompleteRegistration')
      } else {
        // Wrong password
        showValidationError(
          passwordInput,
          "Incorrect password. Please try again."
        );
        passwordInput.focus();
        passwordInput.value = "";
      }
    });

    // Handle Enter key in password input
    passwordInput.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        passwordForm.dispatchEvent(new Event("submit"));
      }
    });
  }

  // Video background functionality
  function initializeVideoBackgrounds() {
    const vault = document.querySelector(".collection-vault");
    const video = vault.querySelector(".collection-vault__video");
    const desktopBgImage = vault.dataset.desktopBg;
    const mobileBgImage = vault.dataset.mobileBg;

    // Set up video error handling
    if (video) {
      video.addEventListener("loadeddata", function () {
        console.log("Video loaded successfully");
      });
      video.addEventListener("error", function () {
        console.log("Video failed to load, falling back to images");
        // Fall back to images
        if (desktopBgImage) {
          vault.style.backgroundImage = `url('${desktopBgImage}')`;
        }
        if (mobileBgImage) {
          vault.style.setProperty(
            "--mobile-bg-image",
            `url('${mobileBgImage}')`
          );
        }
      });
    } else {
      // No video, use images as fallback
      if (desktopBgImage) {
        vault.style.backgroundImage = `url('${desktopBgImage}')`;
      }
      if (mobileBgImage) {
        vault.style.setProperty("--mobile-bg-image", `url('${mobileBgImage}')`);
      }
    }
  }

  // Set mobile background image (fallback)
  function setMobileBackground() {
    const vault = document.querySelector(".collection-vault");
    const mobileBg = vault.dataset.mobileBg;

    if (window.innerWidth <= 768 && mobileBg) {
      vault.style.setProperty("--mobile-bg-image", `url('${mobileBg}')`);
    }
  }

  // Initialize video backgrounds
  initializeVideoBackgrounds();

  // Set initial background
  setMobileBackground();

  // Update background on resize
  window.addEventListener("resize", setMobileBackground);

  // Handle back button click to unlock scroll
  const backBtn = document.getElementById("back-btn");
  if (backBtn) {
    backBtn.addEventListener("click", function (e) {
      e.preventDefault();
      unlockBodyScroll();
      // Navigate to home page
      window.location.href = backBtn.href;
    });
  }

  // Music player functionality
  const musicAudio = document.getElementById("music-audio");
  const playBtn = document.getElementById("play-btn");
  const cdContainer = document.getElementById("cd-container");
  const playIcon = document.querySelector(".collection-vault__play-icon");
  const pauseIcon = document.querySelector(".collection-vault__pause-icon");

  if (musicAudio && playBtn && cdContainer) {
    let isPlaying = false;

    // Initialize with rotating class but paused state
    cdContainer.classList.add("rotating", "paused");

    playBtn.addEventListener("click", function () {
      if (isPlaying) {
        // Pause music
        musicAudio.pause();
        isPlaying = false;
        playIcon.style.display = "block";
        pauseIcon.style.display = "none";
        cdContainer.classList.add("paused");
      } else {
        // Play music
        musicAudio.play().catch((error) => {
          console.error("Error playing audio:", error);
        });
        isPlaying = true;
        playIcon.style.display = "none";
        pauseIcon.style.display = "block";
        cdContainer.classList.remove("paused");
        // Ensure rotating class is always present
        if (!cdContainer.classList.contains("rotating")) {
          cdContainer.classList.add("rotating");
        }
      }
    });

    // Handle audio end
    musicAudio.addEventListener("ended", function () {
      isPlaying = false;
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
      cdContainer.classList.add("paused");
    });

    // Handle audio errors
    musicAudio.addEventListener("error", function (e) {
      console.error("Audio error:", e);
    });
  }
});
